// extracted by mini-css-extract-plugin
export default {"base":"CEA39","container":"CUjcv","message":"WBVLO","link":"dsZ3y","icon":"YaTik","openNew":"_1EdlO"};